export default __webpack_public_path__ + "static/media/remove-circle.17c0d219.svg";